module.exports = __webpack_public_path__ + "img/Natural_Resources_Institute_Finland_Luke-300x263.f6ab9d7e.png";